"use client";

import { useLocale, useTranslations } from "next-intl";

// 클라이언트 컴포넌트로 둔다 — 서버의 locale 없는 getLocale()/getTranslations() 는
// 요청 locale 을 headers() 로 읽을 수 있어, ISR 라우트(products/[id] 등)에서 notFound()
// 가 났을 때 런타임 "static to dynamic" 500 이 될 수 있다. locale·메시지는 [locale]
// layout 의 NextIntlClientProvider 에서 받는다.
//
// 레이아웃: fixed 오버레이가 아니라 **일반 흐름**에 둔다. [locale]/layout 이 이미
// Navbar / Footer 를 감싸고 있어서, 오버레이를 걷어내야 실제 네비게이션·푸터가 보인다.
// 상단 여백은 MainContent 의 `pt-page-safe md:pt-0` 가 이미 담당한다(여기서 pt-safe 를
// 또 주면 iOS 에서 Navbar 아래 중복 gap).
export default function NotFound() {
  const locale = useLocale();
  const t = useTranslations("common.errors.notFound");

  return (
    <section className="flex flex-col items-center px-6 pt-10 pb-14 text-center md:pt-16 md:pb-20">
      <h1 className="text-[32px] font-bold leading-tight tracking-tight text-gray-900 md:text-[58px]">
        {t("title")}
      </h1>

      {/* 장식용 일러스트 — 의미는 헤드라인이 전달하므로 alt=""+aria-hidden.
          /public 자산은 Vercel 이미지 최적화(과금)를 거치지 않고 정적 CDN 에서
          그대로 서빙하므로 next/image 가 아니라 평범한 <img> 를 쓴다. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/404.webp"
        width={1200}
        height={645}
        alt=""
        aria-hidden="true"
        className="mt-6 h-auto w-[260px] max-w-full md:mt-9 md:w-120"
      />

      <p className="mt-9 text-sm text-gray-500 md:mt-12 md:text-base">
        {t("message")}
      </p>

      <a
        href={`/${locale}`}
        className="mt-5 inline-flex items-center justify-center rounded-xl bg-orange-500 px-8 py-3.5 text-sm font-medium text-white shadow-md shadow-orange-200/50 transition-all duration-200 hover:bg-orange-600 hover:shadow-lg hover:shadow-orange-200/60 active:scale-95 md:mt-6 md:text-base"
      >
        {t("backToHome")}
      </a>
    </section>
  );
}
